module.exports = __webpack_public_path__ + "static/media/football-carousel-1024x1366.1f145e08.jpg";